<template>
  <div>
    <h1 class="section-divider-underline">{{ $t("employeeProfile.bank") }}</h1>
    <div class="row">
      <div class="col-md-6 tw-space-y-4">
        <div class="row">
          <label class="form-col-label control-label col-md-5 tw-text-right">{{
            $t("employeeProfile.bank")
          }}</label>
          <div class="col-md-7">
            <select
              v-model="model.bank_id"
              class="form-select"
              :class="{ 'is-invalid': errors.has('bank_id') }"
            >
              <option :value="null" selected style="display: block">
                {{ $t("select") }}
              </option>
              <option
                v-for="(bank, index) in formViewDatas.bank"
                :key="index"
                :value="bank.bank_id"
              >
                {{ bank.bank_name }}
              </option>
            </select>
            <div class="invalid-feedback" v-if="errors.has('bank_id')">
              {{ errors.first("bank_id") }}
            </div>
          </div>
        </div>

        <div class="row">
          <label class="form-col-label control-label col-md-5 tw-text-right">{{
            $t("employeeProfile.bankAccountNumber")
          }}</label>
          <div class="col-md-7">
            <input
              type="text"
              class="form-control"
              v-model.trim="model.bank_account_number"
              :class="{ 'is-invalid': errors.has('bank_account_number') }"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('bank_account_number')"
            >
              {{ errors.first("bank_account_number") }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 tw-space-y-4">
        <div class="row">
          <label class="form-col-label control-label col-md-5 tw-text-right">{{
            $t("employeeProfile.bankAccountName")
          }}</label>
          <div class="col-md-7">
            <input
              type="text"
              class="form-control"
              v-model.trim="model.bank_account_name"
              :class="{ 'is-invalid': errors.has('bank_account_name') }"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('bank_account_name')"
            >
              {{ errors.first("bank_account_name") }}
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <label class="form-col-label control-label col-md-5 tw-text-right">{{
            $t("employeeProfile.fpSerialCard")
          }}</label>
          <div class="col-md-7">
            <input
              type="text"
              class="form-control"
              v-model.trim="model.fp_serial_card"
              :class="{ 'is-invalid': errors.has('fp_serial_card') }"
            />
            <div class="invalid-feedback" v-if="errors.has('fp_serial_card')">
              {{ errors.first("fp_serial_card") }}
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";

export default {
  name: "bank",
  props: ["value", "validation"],
  data() {
    return {
      model: {},
      errors: new Errors(),
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    ...mapState("humanResource/employeeProfile", [
      "formViewDatas",
      "edit_data",
    ]),
  },
  methods: {},
  watch: {
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
